import { render } from "./DropdownDivider.vue?vue&type=template&id=f194523c"
import script from "./DropdownDivider.vue?vue&type=script&lang=js"
export * from "./DropdownDivider.vue?vue&type=script&lang=js"

const cssModules = script.__cssModules = {}
import style0 from "./DropdownDivider.vue?vue&type=style&index=0&id=f194523c&module=true&lang=css"
cssModules["$style"] = style0
script.render = render

export default script